import { render, staticRenderFns } from "./SettingsDocumentation.vue?vue&type=template&id=48f04979&scoped=true"
import script from "./SettingsDocumentation.vue?vue&type=script&lang=js"
export * from "./SettingsDocumentation.vue?vue&type=script&lang=js"
import style0 from "@/assets/docs/styles/documentation.css?vue&type=style&index=0&id=48f04979&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f04979",
  null
  
)

export default component.exports